<template>
  <div :class="$attrs.class">
    <input
      v-bind="$attrs"
      type="text"
      class="appearance-none rounded-none relative block w-full px-5 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5 lg:text-lg"
      v-model="value"
    />
  </div>
</template>

<script>
import { computed } from "vue";
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      required: false,
    }
  },
  setup(props, { emit }) {
    const value = computed({
      get() {
        return props.modelValue || "";
      },
      set(newValue) {
        emit("update:modelValue", newValue);
      },
    });

    return { value };
  },
};
</script>

<style></style>
